// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"767":"forum/components/ActorAuditModal","920":"forum/components/AuditModal","936":"forum/components/DiscussionAuditModal","985":"forum/components/UserAuditModal"}[chunkId] + ".js";
};